import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { useEffect } from 'react';

export type NotificationType = 'success' | 'error' | 'loading';

interface NotificationProps {
  type: NotificationType;
  message: string;
  onClose?: () => void;
  autoClose?: boolean;
  duration?: number;
}

export function Notification({ type, message, onClose, autoClose = true, duration = 700 }: NotificationProps) {
  useEffect(() => {
    if (autoClose && type !== 'loading' && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose, type]);

  const bgColor = type === 'success' ? 'bg-emerald-500' : type === 'error' ? 'bg-red-500' : 'bg-blue-500';
  const Icon = type === 'success' ? CheckCircle2 : type === 'error' ? XCircle : Loader2;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
      <div className={`${bgColor} text-white rounded-2xl p-6 max-w-sm w-full shadow-xl animate-in zoom-in-95 duration-200`}>
        <div className="flex items-center gap-4">
          <Icon className={`w-8 h-8 flex-shrink-0 ${type === 'loading' ? 'animate-spin' : ''}`} />
          <p className="text-base font-medium leading-relaxed">{message}</p>
        </div>
      </div>
    </div>
  );
}
